import React from "react";

import Song from "../../containers/Song";
import Countdown from "../../containers/Countdown";
import BackToHome from "../../containers/BackToHome";

import saveTheDateImg from "../../assets/images/saveTheDate/SaveTheDate.jpg";
import "./style.css";

const SaveTheDate = () => {
  return (
    <section className="std-section">
      <img src={saveTheDateImg} alt="Save the Date" className="std-bg" />

      <div className="std-content">
        <p className="std-label">Save the Date</p>
        <div className="std-rule"></div>
        <h1 className="std-names">Lucero &amp; Miguel</h1>
        <div className="std-rule"></div>
        <p className="std-date">19 · Septiembre · 2026</p>
        <p className="std-countdown-label">Nuestra boda comienza en</p>
        <div data-aos="zoom-in">
          <Countdown />
        </div>
      </div>

      <Song />
      <BackToHome />
    </section>
  );
};

export default SaveTheDate;
